module.exports = __webpack_public_path__ + "static/media/gta.6a7aad4c.eot";